export const headlineStyle = {
  color: '#666666',
  fontSize: '16px',
  lineHeight: '28px',
  letterSpacing: '0.15px',
  fontStyle: 'normal',
  mb: '8px',
}

export const titleStyle = {
  color: 'black',
  fontSize: '20px',
  lineHeight: '32px',
  letterSpacing: '0.15px',
  fontStyle: 'normal',
  fontWeight: 500,
  mb: '4px',
}

export const titleCountStyle = {
  fontFamily: 'Roboto',
  fontStyle: 'normal',
  fontWeight: 400,
  fontSize: 48,
  lineHeight: '56.02px',
}
